<template>
  <!-- 发布专利页面 -->
  <div class="article">
    <div class="article_title">
      <el-form ref="form" :rules="rules" :model="form" label-width="107px">
        <el-form-item>
          <div class="article_top">
            <div>专利发布</div>
          </div>
        </el-form-item>
        <el-form-item label="专利名称" prop="patent_name">
          <el-input
            style="width: 540px"
            placeholder="请输入专利名称"
            v-model="form.patent_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="专利号" prop="patent_number">
          <el-input
            style="width: 324.1px"
            placeholder="请输入专利号"
            v-model="form.patent_number"
          ></el-input>
        </el-form-item>
        <el-form-item label="授权日期" prop="authorization_date">
          <el-date-picker
            style="width: 200.1px"
            type="date"
            v-model="form.authorization_date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="专利类型" prop="patent_type_name">
          <el-select
            style="width: 200.1px"
            v-model="form.patent_type_name"
            placeholder="请选择类型"
            @change="selectSubjectItem($event)"
          >
            <el-option
              v-for="item in patenttype"
              :key="item.id"
              :label="item.name"
              :value="{ code: item.id, labels: item.name }"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="专利门类" prop="patent_category_name">
          <el-select
            style="width: 200.1px"
            v-model="form.patent_category_name"
            placeholder="请选择门类"
            @change="selectSubjectItems($event)"
          >
            <el-option
              v-for="item in patentdoor"
              :key="item.id"
              :label="item.name"
              :value="{ codes: item.id, labeles: item.name }"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="附图">
          <div class="HeadPortrait_text">
            <el-upload
              class="Enterprise_LoGo_img"
              action="https://tsadmin.qudong.com/ApiUpload/upload_many"
              :headers="headers"
              :show-file-list="false"
              multiple
              name="file[]"
              :on-success="successAgreements_text"
              :before-upload="beforeRef_text"
            >
              <img
                v-if="imageUrls"
                :src="imageUrls"
                class="Enterprise_LoGos_text"
              />
              <i v-else class="el-icon-plus Enterprise_LoGo_img_icon"></i>
            </el-upload>
            <span>请上传大小不能超过2M。支持格式：.jpg、.png、.jpeg</span>
          </div>
        </el-form-item>
        <el-form-item label="专利简介" prop="patent_profile">
          <el-input
            style="width: 540px; height: 80px"
            placeholder="请输入200字以内简介..."
            type="textarea"
            :rows="3"
            resize="none"
            maxlength="200"
            v-model="form.patent_profile"
          ></el-input>
        </el-form-item>
        <el-form-item label="专利说明" prop="patent_description">
          <el-input
            style="width: 540px; height: 120px"
            placeholder="请输入800字以内简介..."
            type="textarea"
            :rows="5"
            resize="none"
            maxlength="800"
            v-model="form.patent_description"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="article_button">
            <el-button @click="onSubmit()">提交审核</el-button>

            <el-button @click="onSubmits()">保存草稿</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  patent_type,
  patent_door,
  article_patent,
  article_updatedata,
  userInfos,
} from "../../api/api";
let token = localStorage.getItem("token");
export default {
  metaInfo() {
    return {
      title: "专利发布",
      meta: [
        {
          name: "keywords",
          content:
            "驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。",
        },
        {
          name: "description",
          content:
            " 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网",
        },
      ],
    };
  },
  name: "Patent",
  created() {
    this.qulist();
    this.qulist_fen();
    this.query();
    //this.onSubmits();
    userInfos({}).then((res) => {
      ////console.log(res);
      //  0普通
      // 1专家
      // 2机构
      var isbusiness = res.data.data.business;
      if (isbusiness == 0) {
        this.$confirm("您认证的信息还未通过暂时无法发布", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push({ path: "/PersonalCenter/index" });
          })
          .catch(() => {
            this.$router.push({ path: "/PersonalCenter/index" });
          });
      }
    });
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          //  ////console.log(time.getTime());
          //  ////console.log(Date.now());
          return time.getTime() > Date.now();
        },
      },
      patenttype: [], //专利分类
      patentdoor: [], //专利门类
      headers: {
        token: token,
      }, //请求头传token
      rows: "",
      imageUrls: "",
      // 修改传递过来的值
      form: {
        authorization_date: "", //授权日期
        patent_number: "", //专利号
        patent_name: "", //专利名称
        patent_category_name: "", //专利门类
        patent_category_id: "",
        atent_type_id: "",
        chart_img: "",
        patent_type_name: "", //专利类型
        patent_type_id: "",
        patent_description: "", // 专利说明
        patent_profile: "", // 专利简介
      },
      rules: {
        patent_name: [
          { required: true, message: "请输入活动名称", trigger: "change" },
        ],
        patent_number: [
          { required: true, message: "请输入专利号", trigger: "change" },
        ],
        authorization_date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        patent_type_name: [
          { required: true, message: "请选择专利类型", trigger: "change" },
        ],
        patent_category_name: [
          { required: true, message: "请选择专利门类", trigger: "change" },
        ],
        patent_profile: [
          { required: true, message: "请输入简介", trigger: "change" },
        ],
        patent_description: [
          { required: true, message: "请输入专利说明", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    // 接收过来的值
    query() {
      let id = this.$route.query.id;
      let type = this.$route.query.type;
      if (id != undefined) {
        article_updatedata({
          id: id,
          type: type,
        }).then((res) => {
          ////console.log(res);
          let querylist = res.data.data;
          this.form.patent_name = querylist.patent_name;
          this.form.patent_number = querylist.patent_number;
          this.form.authorization_date = querylist.authorization_date;
          this.form.patent_type_id = querylist.patent_type_id;
          this.form.patent_type_name = querylist.patent_type_name;
          this.form.patent_category_id = querylist.patent_category_id;
          this.imageUrls = querylist.chart_img;
          this.form.patent_category_name = querylist.patent_category_name;
          this.form.patent_profile = querylist.patent_profile;
          this.form.patent_description = querylist.patent_description;
        });
      }
    },
    selectSubjectItem(event) {
      this.form.patent_type_id = event.code;
      this.form.patent_type_name = event.labels;
    },
    selectSubjectItems(event) {
      this.form.patent_category_id = event.codes;
      this.form.patent_category_name = event.labeles;
    },
    qulist() {
      patent_type({}).then((res) => {
        this.patenttype = res.data.data;
      });
    },
    qulist_fen() {
      patent_door({}).then((res) => {
        this.patentdoor = res.data.data;
      });
    },
    // 保存草稿
    onSubmits() {
      if (
        this.form.authorization_date == "" ||
        this.form.authorization_date == null
      ) {
        this.$message.error("请选择日期");
        return false;
      }

      let date = new Date(this.form.authorization_date);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = new Date().getHours();
      h = h < 10 ? "0" + h : h;
      let f = new Date().getMinutes();
      f = f < 10 ? "0" + f : f;
      let s = new Date().getSeconds();
      s = s < 10 ? "0" + s : s;
      const time = y + "-" + m + "-" + d + " " + h + ":" + f + ":" + s;
      this.form.authorization_date = time;
      let id = this.$route.query.id;
      if (id == undefined) {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            article_patent({
              patent_name: this.form.patent_name,
              patent_number: this.form.patent_number,
              authorization_date: this.form.authorization_date,
              patent_type_id: this.form.patent_type_id,
              patent_type_name: this.form.patent_type_name,
              patent_category_id: this.form.patent_category_id,
              patent_category_name: this.form.patent_category_name,
              chart_img: this.imageUrls,
              patent_profile: this.form.patent_profile,
              patent_description: this.form.patent_description,
              status: 3,
            }).then((res) => {
              if (res.data.code == 200) {
                ////console.log(this.form.patent_name);
                this.$message.success("保存成功");
                setTimeout(() => {
                  this.$router.push("/PersonalCenter/Releases");
                }, 1500);
              }
            });
          }
        });
      } else {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            article_patent({
              id: id,
              patent_name: this.form.patent_name,
              patent_number: this.form.patent_number,
              authorization_date: this.form.authorization_date,
              patent_type_id: this.form.patent_type_id,
              patent_type_name: this.form.patent_type_name,
              patent_category_id: this.form.patent_category_id,
              patent_category_name: this.form.patent_category_name,
              chart_img: this.imageUrls,
              patent_profile: this.form.patent_profile,
              patent_description: this.form.patent_description,
              status: 3,
            }).then((res) => {
              if (res.data.code == 200) {
                this.$message.success("保存成功");
                setTimeout(() => {
                  this.$router.push("/PersonalCenter/Releases");
                }, 1500);
              }
            });
          }
        });
      }
    },
    //提交审核
    onSubmit() {
      if (
        this.form.authorization_date == "" ||
        this.form.authorization_date == null
      ) {
        this.$message.error("请选择日期");
        return false;
      }

      let date = new Date(this.form.authorization_date);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = new Date().getHours();
      h = h < 10 ? "0" + h : h;
      let f = new Date().getMinutes();
      f = f < 10 ? "0" + f : f;
      let s = new Date().getSeconds();
      s = s < 10 ? "0" + s : s;
      const time = y + "-" + m + "-" + d + " " + h + ":" + f + ":" + s;
      this.form.authorization_date = time;
      let id = this.$route.query.id;
      if (id == undefined) {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            article_patent({
              patent_name: this.form.patent_name,
              patent_number: this.form.patent_number,
              authorization_date: this.form.authorization_date,
              patent_type_id: this.form.patent_type_id,
              patent_type_name: this.form.patent_type_name,
              patent_category_id: this.form.patent_category_id,
              patent_category_name: this.form.patent_category_name,
              chart_img: this.imageUrls,
              patent_profile: this.form.patent_profile,
              patent_description: this.form.patent_description,
            }).then((res) => {
              if (res.data.code == 200) {
                ////console.log(this.form.patent_name);
                this.$message.success("发布成功");
                setTimeout(() => {
                  this.$router.push("/PersonalCenter/Releases");
                }, 1500);
              }
            });
          }
        });
      } else {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            article_patent({
              id: id,
              patent_name: this.form.patent_name,
              patent_number: this.form.patent_number,
              authorization_date: this.form.authorization_date,
              patent_type_id: this.form.patent_type_id,
              patent_type_name: this.form.patent_type_name,
              patent_category_id: this.form.patent_category_id,
              patent_category_name: this.form.patent_category_name,
              chart_img: this.imageUrls,
              patent_profile: this.form.patent_profile,
              patent_description: this.form.patent_description,
            }).then((res) => {
              if (res.data.code == 200) {
                this.$message.success("修改成功");
                setTimeout(() => {
                  this.$router.push("/PersonalCenter/Releases");
                }, 1500);
              }
            });
          }
        });
      }
    },
    // 上传图片
    successAgreements_text(res) {
      var that = this;
      that.imageUrls = res.data[0];
    },
    // 请求前限制上传条件
    beforeRef_text(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG || !isLt2M) {
        this.$message.error("上传文件只能是图片格式，且大小不能超过2M");
      }
      return isJPG, isLt2M;
    },
  },
};
</script>

<style scoped>
.article {
  width: 940px;
  background-color: #fff;
}
.article >>> .el-icon-plus:before {
  content: none;
}
.HeadPortrait_text {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.HeadPortrait_text span {
  margin-left: 20px;
  margin-top: 77px;
}
.HeadPortrait_text .Enterprise_LoGo_img {
  width: 121px;
  height: 124px;
  cursor: pointer;
  background-image: url("../../assets/img/article.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.Enterprise_LoGo_img .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.Enterprise_LoGo_img .el-upload:hover {
  border-color: #409eff;
}
.Enterprise_LoGo_img_icon {
  font-size: 28px;
  color: #8c939d;
  width: 121px;
  height: 124px;
  line-height: 160px;

  text-align: center;
}
.Enterprise_LoGos_text {
  width: 121px;
  height: 124px;
  display: block;
  background: #fff;
}
.el-button {
  border: 1px solid #999999;
  color: #999999;
  border-radius: 10px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  margin-right: 60px;
  margin-left: 60px;
}

.el-button {
  width: 120px;
  height: 48px;
}

.article_top > div {
  width: 540px;
  text-align: center;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-top: 39px;
}
.article_button {
  width: 540px;
  text-align: center;
  margin-top: 30px;
}
.article_up {
  display: flex;
  height: 124px;
}
.article_img {
  width: 121px;
  height: 124px;
  margin-right: 20px;
}
.article_title {
  margin-left: 49px;
}
</style>